<template>
  <div class="delivery-wrap">
    <div class="header-title">投放主体管理</div>
    <div class="flex">
      <div class="filter">
        <el-input v-model="search" style="width: 200px" placeholder="请输入公司名称或ID"></el-input>
        <el-button style="margin-left: 16px" @click="resetFilter">重置</el-button>
        <el-button type="primary" @click="searchData">查询</el-button>
      </div>
      <el-button type="primary" @click="handleAdd">添加投放主体</el-button>
    </div>
    <el-table
      :data="list"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      ref="table"
    >
      <el-table-column label="ID" prop="id" width="200"></el-table-column>
      <el-table-column label="公司名称" prop="deliveryName"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑 </el-button>
          <el-button class="delete-btn" type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <self-pagination
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      @getCurrentPage="changePage"
      @handleSizeChange="handleSizeChange"
    ></self-pagination>
    <el-dialog
      :title="modalType == 'add' ? '添加投放主体' : '编辑投放主体'"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form :model="modalForm" ref="modalFormRef" label-width="100px">
        <el-form-item
          label="公司名称: "
          prop="deliveryName"
          :rules="[{ required: true, message: '公司名称不能为空' }]"
        >
          <el-input
            maxlength="20"
            show-word-limit
            placeholder="请输入公司名称"
            v-model="modalForm.deliveryName"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm" v-loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addDeliverySub,
  getDeliverySubList,
  updateDeliverySub,
  deleteDeliverySub,
} from "@/api/api.js";
export default {
  data() {
    return {
      search: "",
      list: [],
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      modalForm: {
        deliveryName: "",
        id: "",
      },
      modalType: "add",
      dialogVisible: false,
      btnLoading: false,
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.searchData();
  },

  methods: {
    resetFilter() {
      this.search = "";
      this.changePage(1);
    },
    searchData() {
      getDeliverySubList({
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        search: this.search,
      }).then((res) => {
        if (res.code == "0000") {
          this.list = res.data.list;
          this.pageData.total = res.data.total;
        }
      });
    },
    handleAdd() {
      this.modalForm = {
        deliveryName: "",
      };
      this.modalType = "add";
      this.dialogVisible = true;
    },
    handleEdit(data) {
      this.modalForm = {
        deliveryName: data.deliveryName,
        id: data.id,
      };
      this.modalType = "edit";
      this.dialogVisible = true;
    },
    handleConfirm() {
      this.$refs.modalFormRef.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          if (this.modalType == "add") {
            addDeliverySub({
              deliveryName: this.modalForm.deliveryName,
            }).then((res) => {
              this.btnLoading = false;
              if (res.code == "0000") {
                this.$message.success("添加成功");
                this.changePage(1);
                this.dialogVisible = false;
              }
            });
          } else {
            updateDeliverySub({
              deliveryName: this.modalForm.deliveryName,
              id: this.modalForm.id,
            }).then((res) => {
              this.btnLoading = false;
              if (res.code == "0000") {
                this.$message.success("编辑成功");
                this.changePage(1);
                this.dialogVisible = false;
              }
            });
          }
          console.log(this.modalForm.deliveryName);
        } else {
          return false;
        }
      });
    },
    handleDelete(data) {
      this.$confirm("此操作将永久删除该主体, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteDeliverySub({ id: data.id }).then((res) => {
          if (res.code == "0000") {
            this.$message.success("删除成功");
            this.changePage(1);
          }
        });
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    handleSizeChange(size) {
      this.pageData.size = size;
      this.pageData.page = 1;
      this.searchData();
    },
  },
};
</script>

<style lang="less" scoped>
.delivery-wrap {
  margin: 16px;
  height: calc(100vh - 110px);
  padding: 16px 24px 16px 24px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .header-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    flex: 1;
    margin-bottom: 16px;
  }
  .filter {
    flex: 1;
    margin-bottom: 16px;
  }
}
</style>
